import React from 'react';
import { useZoom } from '../contexts/ZoomContext';

interface ZoomableContentProps {
    children: React.ReactNode;
}

const ZoomableContent: React.FC<ZoomableContentProps> = ({ children }) => {
    const { zoomLevel } = useZoom();

    return (
        <div
            className="zoomable-content"
            style={{
                fontSize: `${100 * zoomLevel}%`,
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                minHeight: 0, // Important for proper scrolling
                overflow: 'auto'
            }}
        >
            {children}
        </div>
    );
};

export default ZoomableContent; 